"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditModeHelper = void 0;
var environment_helper_1 = require("./environment.helper");
exports.EditModeHelper = {
    toggleEditingMode: function () {
        this.setAttrIsEditingToBody(!this.isEditingModeEnabled());
    },
    isEditingModeEnabled: function () {
        return this.getAttrIsEditingFromBody() === "true";
    },
    setAttrIsEditingToBody: function (value) {
        if (environment_helper_1.EnvironmentHelper.isClientSide() && typeof document === "object") {
            window.document.body.setAttribute("isEditing", "".concat(value));
        }
    },
    getAttrIsEditingFromBody: function () {
        if (environment_helper_1.EnvironmentHelper.isClientSide() && typeof document === "object") {
            return window.document.body.getAttribute("isEditing") || "false";
        }
        else {
            return "false";
        }
    },
};
